import isEmpty from 'lodash/isEmpty'

// Kept free of React so server modules (the platform tile mapping) can share
// the chip colour rule with DiscountChip.
export const getColor = (type: string) => {
  const lowerType = type.toLowerCase()
  switch (type) {
    case 'black_friday':
    case 'black_week':
    case 'cyber_monday':
      return 'black'
    case 'outlet':
      return 'red'

    default:
      if (lowerType.includes('clover')) {
        return 'clover'
      }
      if (lowerType.includes('magma')) {
        return 'magma'
      }
      if (lowerType.includes('newclassics')) {
        return 'newclassics'
      }
      if (lowerType.includes('end_season_sale_large')) {
        return 'end_season_sale_large'
      }
      if (lowerType.includes('end_season_sale_small') || lowerType.includes('end_season_sale')) {
        return 'end_season_sale_small'
      }
      if (lowerType.includes('summer_sale_large')) {
        return 'summer_sale_large'
      }
      if (lowerType.includes('summer_sale_small') || lowerType.includes('summer_sale')) {
        return 'summer_sale_small'
      }
      if (lowerType.includes('valentine_a_large')) {
        return 'valentine_a_large'
      }
      if (lowerType.includes('valentine_a_small') || lowerType.includes('valentine_a')) {
        return 'valentine_a_small'
      }
      if (lowerType.includes('valentine_b_large')) {
        return 'valentine_b_large'
      }
      if (lowerType.includes('valentine_b_small') || lowerType.includes('valentine_b')) {
        return 'valentine_b_small'
      }
      if (lowerType.includes('blacksale')) {
        return 'blacksale'
      }
      if (lowerType.includes('trendhimclubexclusive')) {
        return 'trendhimclubexclusive'
      }
      if (lowerType.includes('lateseasonsalesvg')) {
        return 'lateseasonsalesvg'
      }
      if (lowerType.includes('lateseasonsale')) {
        return 'lateseasonsale'
      }
      if (lowerType.includes('sale')) {
        return 'sale'
      }
      return isEmpty(type) ? 'red' : type
  }
}
